import { disambiguateExcelHeaders } from './disambiguateExcelHeaders';

const CATEGORY_COLUMN_REGEX = /^CATEGORIA\s+([a-f0-9]{24})$/i;
const NOTE_COLUMN_REGEX = /^NOTA(_\d+)?$/;

export type PartnerExcelCategoryColumn = {
  columnKey: string;
  categoryId: string;
};

export type PartnerExcelDynamicColumns = {
  categoryColumns: PartnerExcelCategoryColumn[];
  noteColumnKeys: string[];
  invalidCategoryIds: string[];
};

export const parsePartnerExcelDynamicColumns = (
  rawHeaders: (string | number | null | undefined)[],
  partnerCategories: { _id?: string }[] = []
): PartnerExcelDynamicColumns => {
  const societyCategoryIds = new Set(
    partnerCategories
      .map((category) => category?._id)
      .filter((id): id is string => Boolean(id))
      .map((id) => String(id).toLowerCase())
  );

  const categoryColumns: PartnerExcelCategoryColumn[] = [];
  const noteColumnKeys: string[] = [];
  const invalidCategoryIds: string[] = [];

  const disambiguatedHeaders = disambiguateExcelHeaders(rawHeaders);

  disambiguatedHeaders.forEach((normalizedHeader) => {
    if (!normalizedHeader) return;

    const categoryMatch = normalizedHeader.match(CATEGORY_COLUMN_REGEX);

    if (categoryMatch) {
      const categoryId = categoryMatch[1].toLowerCase();

      categoryColumns.push({
        columnKey: normalizedHeader,
        categoryId,
      });

      if (!societyCategoryIds.has(categoryId)) {
        invalidCategoryIds.push(categoryId);
      }

      return;
    }

    if (NOTE_COLUMN_REGEX.test(normalizedHeader)) {
      noteColumnKeys.push(normalizedHeader);
    }
  });

  return {
    categoryColumns,
    noteColumnKeys,
    invalidCategoryIds: [...new Set(invalidCategoryIds)],
  };
};
